<template>
  <div class="new-messenger-container">
    <client-only>
      <messenger-full />
    </client-only>
    <!-- <new-messenger /> -->
  </div>
</template>

<script>
// import NewMessenger from '~/marketplace-front-core/components/newMessenger/NewMessenger'
import MessengerFull from '@/marketplace-front-core/components/gotchi/Message/MessengerFull.vue'

export default {
  name: 'PageMessenger',
  components: { MessengerFull },
  layout: 'messenger',
  head () {
    const i18nHead = this.$nuxtI18nHead({ addSeoAttributes: true })
    return {
      titleTemplate: '%s',
      title: this.$t('project.seo.messenger.title'),
      htmlAttrs: {
        ...i18nHead.htmlAttrs
      },
      meta: [
        ...i18nHead.meta,
        { hid: 'description', name: 'description', content: this.$t('project.seo.messenger.description') }
      ],
      link: [
        ...this.metaLink(i18nHead.link)
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.new-messenger-container {
  // height: 100%;
}
</style>
